// src/plugins/vuetify.js
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

// Colores de Google Material Design
const googleBlue = {
  base: '#1a73e8',
  lighten5: '#e8f0fe',
  lighten4: '#d2e3fc',
  lighten3: '#a8c7fa',
  lighten2: '#669df6',
  lighten1: '#4285f4',
  darken1: '#1967d2',
  darken2: '#185abc',
  darken3: '#174ea6',
  darken4: '#1440a4',
};

const googleGrey = {
  base: '#5f6368',
  lighten5: '#f8f9fa',
  lighten4: '#f1f3f4',
  lighten3: '#e8eaed',
  lighten2: '#dadce0',
  lighten1: '#9aa0a6',
  darken1: '#3c4043',
  darken2: '#202124',
  darken3: '#1d1e22',
  darken4: '#18191c',
};

// Otros colores del sistema de Google
const googleRed = '#d93025';
const googleGreen = '#1e8e3e';
const googleYellow = '#f9ab00';

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    options: {
      customProperties: true, // Habilita variables CSS
    },
    themes: {
      light: {
        primary: googleBlue.base,
        secondary: googleGrey.base,
        accent: googleYellow,
        error: googleRed,
        info: googleBlue.lighten1,
        success: googleGreen,
        warning: googleYellow,
        
        // Colores personalizados para componentes específicos
        'primary-lighten': googleBlue.lighten5,
        'primary-darken': googleBlue.darken1,
        'grey-background': googleGrey.lighten5,
        'grey-divider': googleGrey.lighten3,
        'grey-input': googleGrey.lighten4,
        'grey-text': googleGrey.darken1,
      },
      dark: {
        primary: googleBlue.lighten1,
        secondary: googleGrey.lighten1,
        accent: googleYellow,
        error: '#f28b82', // Versión clara de rojo para modo oscuro
        info: googleBlue.lighten2,
        success: '#81c995', // Versión clara de verde para modo oscuro
        warning: '#fdd663', // Versión clara de amarillo para modo oscuro
        
        // Colores personalizados para componentes específicos
        'primary-lighten': googleBlue.darken3,
        'primary-darken': googleBlue.lighten1,
        'grey-background': googleGrey.darken2,
        'grey-divider': googleGrey.darken1,
        'grey-input': googleGrey.darken1,
        'grey-text': googleGrey.lighten2,
      },
    },
  },
  // Personaliza los estilos de componentes predeterminados de Vuetify
  breakpoint: {
    thresholds: {
      xs: 600,
      sm: 960,
      md: 1280,
      lg: 1920,
    },
  },
});